import {
    createRouter,
    createWebHistory
} from 'vue-router'


const routes = [{
    path: '/',
    redirect: '/index'
},
{
    path: '/index',
    meta: {
        title: '首页'
    },
    component: () => import('@/views/MyHome.vue')
},
{
    path: '/platformAnnouncements',
    meta: {
        title: '平台公告'
    },
    component: () => import('@/views/PlatformAnnouncements.vue')
},
{
    path: '/platformAnnouncementsDetail',
    meta: {
        title: '平台公告详情'
    },
    component: () => import('@/views/PlatformAnnouncementsDetail.vue')
},
{
    path: '/aboutventureCapital',
    meta: {
        title: '关于创投'
    },
    component: () => import('@/views/AboutVentureCapital.vue')
},
{
    path: '/concealedWork',
    meta: {
        title: '隐蔽工程验收验量公示'
    },
    component: () => import('@/views/concealedWork.vue')
},
{
    path: '/blackList',
    meta: {
        title: '黑名单公示'
    },
    component: () => import('@/views/blackList.vue')
},
{
    path: '/platformDynamics',
    meta: {
        title: '平台动态'
    },
    component: () => import('@/views/PlatformDynamics.vue')
},
{
    path: '/platformDynamicsDetail',
    meta: {
        title: '平台动态详情'
    },
    component: () => import('@/views/PlatformDynamicsDetail.vue')
},
{
    path: '/bulletinII',
    meta: {
        title: '公告二级'
    },
    component: () => import('@/views/BulletinII.vue')
}
]


const router = createRouter({
    routes,
    history: createWebHistory()
})


router.beforeEach((to, from, next) => {
    // if (to.meta.title) {
    //     document.title = to.meta.title
    // }
    document.title = "江西萍乡创投集团数字化集采平台"
    document.documentElement.scrollTop = 0
    next()
})

export default router